module.exports = __webpack_public_path__ + "static/img/career-course-xyts.ba64be0d.png";